import styled from 'styled-components';
const Container = styled.section `
  position: absolute;
  height: 100%;
  width: 100%;
`;
const GoogleMapStyles = {
    Container,
};
export default GoogleMapStyles;
